/**
 * Payment date helpers for payments-due event rows.
 * Parses naive API timestamps as local calendar dates (avoids UTC day shift).
 */

const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function parsePaymentDateLocal (raw) {
  if (raw == null || raw === '') {
    return null
  }
  const match = String(raw).match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (match) {
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
  }
  const parsed = new Date(raw)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

function startOfLocalDay (d) {
  const copy = new Date(d)
  copy.setHours(0, 0, 0, 0)
  return copy
}

function getIsoWeekStart (d) {
  const day = startOfLocalDay(d)
  const dayOfWeek = day.getDay()
  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek
  day.setDate(day.getDate() + diffToMonday)
  return day
}

export function isPaymentDateThisWeek (paymentDate, referenceDate = new Date()) {
  const parsed = parsePaymentDateLocal(paymentDate)
  if (!parsed) {
    return false
  }
  const weekStart = getIsoWeekStart(referenceDate)
  const weekEnd = new Date(weekStart)
  weekEnd.setDate(weekStart.getDate() + 6)
  weekEnd.setHours(23, 59, 59, 999)
  const paymentDay = startOfLocalDay(parsed)
  return paymentDay >= weekStart && paymentDay <= weekEnd
}

export function formatPaymentDateDisplay (paymentDate) {
  const parsed = parsePaymentDateLocal(paymentDate)
  if (!parsed) {
    return ''
  }
  return `${parsed.getDate()} ${MONTH_LABELS[parsed.getMonth()]} ${parsed.getFullYear()}`
}

export function getPaymentDateCellClass (paymentDate, referenceDate = new Date()) {
  if (!parsePaymentDateLocal(paymentDate)) {
    return ''
  }
  const classes = ['Payments-paymentDate']
  if (!isPaymentDateThisWeek(paymentDate, referenceDate)) {
    classes.push('Payments-paymentDate--notThisWeek')
  }
  return classes.join(' ')
}
